import ReviewSidebar from 'automation-ui-canvas/containers/review/ReviewSidebar';
import { ReviewOptionId } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/constants/MenuOptionIds';
export const ReviewOption = {
  id: ReviewOptionId,
  getLabel: () => '',
  ModalComponent: ReviewSidebar
};